<template>
  <el-dialog
      title="用印审批"
      :visible.sync="visible"
      width="500px"
      :before-close="handleClose">

    <el-form :model="form" ref="ruleForm" :rules="rules">
      <el-form-item label="是否审批" label-width="100px" prop="uKeySn">
        <el-switch
            v-model="form.value"
            active-color="#13ce66"
            inactive-color="#ff4949">
        </el-switch>
      </el-form-item>
      <el-form-item label="手机号" label-width="100px" prop="telephone" v-if="form.value">
        <el-input v-model="form.telephone" placeholder="请输入手机号" autocomplete="off"></el-input>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleSubmit">确 定</el-button>
    </span>

  </el-dialog>
</template>

<script>

export default {
  name: "examineAndApprove",
  data() {
    const validPhone = (rule, value, callback) => {
      let reg = /^1[3456789]\d{9}$/;
      if (value === "") {
        callback(new Error("请输入实名手机号码"));
      } else if (!reg.test(value)) {
        callback(new Error("请输入实名手机号码"));
      } else {
        callback();
      }
    };
    return {
      form:{},
      visible: false,
      loading: false,
      rules: {
        telephone: [{required: true, validator: validPhone, trigger: "blur"}],
      },
    };
  },
  methods:{
    show(){
      this.visible = true
    },
    handleSubmit(){
      this.$refs.ruleForm.validate((value) => {
        if (value) {

          this.handleClose(false)
        }
      });
    },
    handleClose() {
      this.updateDialog(false)
    },
    /* 更新visible */
    updateDialog(value) {
      this.visible = value
      // this.$emit('update:visible', value);
    }
  }
}
</script>

<style scoped lang="less">

</style>
